import { render, staticRenderFns } from "./DiseaseAnnoView.vue?vue&type=template&id=17853a86&scoped=true"
import script from "./DiseaseAnnoView.vue?vue&type=script&lang=js"
export * from "./DiseaseAnnoView.vue?vue&type=script&lang=js"
import style0 from "./DiseaseAnnoView.vue?vue&type=style&index=0&id=17853a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17853a86",
  null
  
)

export default component.exports